import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBh9VxU2OKG7FiVR81pjsHeWgkCSWcHxv4",
  authDomain: "lyrical-bolt-438100-r1.firebaseapp.com",
  projectId: "lyrical-bolt-438100-r1",
  storageBucket: "lyrical-bolt-438100-r1.firebasestorage.app",
  messagingSenderId: "639367320239",
  appId: "1:639367320239:web:d0b5d43fa38a0290ca7a5a",
  measurementId: "G-KMJ1RFEDZ0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
            console.error('Service Worker registration failed:', error);
        });
}

export { messaging };
